/* eslint-disable camelcase */
// Disable camelcase until we change it in the Rails API
import React, { useContext } from 'react';
import { css } from '@emotion/core';
import Card from './Card';
import CardTop from './CardTop';
import { spycraftBaseTypes } from '../proptypes/spycraft';
import { Header4, Tag, Paragraph } from './Typography';
import { Play, External } from './UiIcons';
import {
  ssColorWhite,
  ssColorUltraDarkGrey,
  ssColorMidGrey,
  transitionFast,
} from '../constants/style-constants';
import PhrasesContext from './contexts/PhrasesContext';

const iconCss = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const selectIcon = (type) => {
  switch (type) {
    case 'Podcast':
    case 'Video':
      return <Play css={iconCss} width="90" height="90" strokeWidth="1.5" />;
    default:
      return undefined;
  }
};

const selectContentTypeLabel = (phrases, type) => phrases[`${type.toLowerCase()}Label`];

const previewCardCSS = css`
  background-color: ${ssColorUltraDarkGrey};
  padding: 0 1.5rem 1.5rem;
  transition: opacity ${transitionFast};

  .icon {
    transition: opacity ${transitionFast};
    opacity: 0;
  }

  &:hover {
    color: ${ssColorWhite};
    opacity: 0.8;

    .icon {
      opacity: 0.6;
    }
  }
`;

const PreviewCard = ({
  path,
  title,
  image_url,
  type,
  external,
  external_url,
  description,
  showDescription,
  show: {
    title: showTitle,
  },
  ...restProps
}) => {
  const { contentType: contentTypePhrases } = useContext(PhrasesContext);
  const linkAttributes = type === 'Podcast' && external
    ? { href: external_url, target: '_blank', rel: 'noopener noreferrer' }
    : { href: path };
  const Icon = selectIcon(type);
  const contentTypeLabel = selectContentTypeLabel(contentTypePhrases, type);

  return (
    <Card css={previewCardCSS} {...linkAttributes} {...restProps}>
      <CardTop imageUrl={image_url} icon={Icon} />
      <Tag>{contentTypeLabel}</Tag>
      {' '}
      {external && (
        <External
          width="15"
          height="15"
          stroke={ssColorMidGrey}
          strokeWidth="3"
        />
      )}
      <Header4>
        {showTitle && `${showTitle}: `}
        {title}
      </Header4>
      {showDescription && description && (<Paragraph>{description}</Paragraph>)}
    </Card>
  );
};

PreviewCard.defaultProps = {
  image_url: undefined,
  description: undefined,
  show: {
    title: undefined,
  },
  showDescription: true,
};

PreviewCard.propTypes = spycraftBaseTypes;

export default PreviewCard;
